import styled from 'astroturf'
import React from 'react';

import RidibooksLogo from '../svgs/ridibooks.svg';
import RidiselectLogo from '../svgs/ridiselect.svg';
import InstagramIcon from '../svgs/ig.inline.svg';
import FacebookIcon from '../svgs/fb.inline.svg';

const Container = /*#__PURE__*/styled('div', null, {
  displayName: "Container",
  styles: require("./footer-Container.module.css"),
  attrs: null,
  vars: []
});

const FooterWrapper = /*#__PURE__*/styled("footer", null, {
  displayName: "FooterWrapper",
  styles: require("./footer-FooterWrapper.module.css"),
  attrs: null,
  vars: []
});

const Links = /*#__PURE__*/styled('div', null, {
  displayName: "Links",
  styles: require("./footer-Links.module.css"),
  attrs: null,
  vars: []
});

const Divider = /*#__PURE__*/styled("div", null, {
  displayName: "Divider",
  styles: require("./footer-Divider.module.css"),
  attrs: null,
  vars: []
});

const LogoLink = /*#__PURE__*/styled("a", null, {
  displayName: "LogoLink",
  styles: require("./footer-LogoLink.module.css"),
  attrs: null,
  vars: []
});

const SocialLink = /*#__PURE__*/styled("a", null, {
  displayName: "SocialLink",
  styles: require("./footer-SocialLink.module.css"),
  attrs: null,
  vars: []
});

const Copyright = /*#__PURE__*/styled("div", null, {
  displayName: "Copyright",
  styles: require("./footer-Copyright.module.css"),
  attrs: null,
  vars: []
});

const styles = require('./footer-styles.module.css');

interface Props {
  noMarginTop?: boolean;
}

export default function Footer(props: Props) {
  return (
    <Container noMarginTop={props.noMarginTop}>
      <FooterWrapper>
        <Links className={styles.spaceBetween}>
          <div>
            <LogoLink href="https://ridibooks.com/">
              <img src={RidibooksLogo} className={styles.ridibooks} alt="리디북스로 이동" />
            </LogoLink>
            <Divider />
            <LogoLink href="https://select.ridibooks.com/home">
              <img src={RidiselectLogo} className={styles.ridiselect} alt="리디셀렉트로 이동" />
            </LogoLink>
          </div>
          <div>
            <SocialLink href="https://www.instagram.com/ridipaper/?hl=en">
              <InstagramIcon className={styles.icon} />
              <span>인스타그램</span>
            </SocialLink>
            <SocialLink href="https://www.facebook.com/ridibooks">
              <FacebookIcon className={styles.icon} />
              <span>페이스북</span>
            </SocialLink>
          </div>
        </Links>
        <Links narrow>
          <div>
            <a href="https://help.ridibooks.com/hc/ko">고객센터</a>
            <Divider />
            <a href="https://help.ridibooks.com/hc/ko/articles/360026484174">페이퍼 대량 구매 안내</a>
            <Divider />
            <a href="https://ridibooks.com/legal/terms">이용약관</a>
            <Divider className={styles.hideOnMobile} />
          </div>
          <div>
            <a href="https://policy.ridi.com/legal/privacy"><strong>개인 정보 처리 방침</strong></a>
            <Divider />
            <a href="http://ftc.go.kr/www/bizCommView.do?key=232&apv_perm_no=2009322012730202139">사업자 정보 확인</a>
          </div>
        </Links>
        <Copyright>© RIDI Corp.</Copyright>
      </FooterWrapper>
    </Container>
  );
}
